import { useEditor }      from '@tiptap/react';
import { useTranslation } from 'react-i18next';
import Placeholder        from '@tiptap/extension-placeholder';
import StarterKit         from '@tiptap/starter-kit';
import StandPageModel     from '@/models/services/website/StandPageModel';

const editorConfig = (placeholder: string, content: string) => ({
	extensions: [StarterKit, Placeholder.configure({ placeholder })],
	content,
});

export const useStandPageEditors = (activeStandPage: StandPageModel | null) => {
	const { t } = useTranslation();

	const excerptPlaceholder = t('pages.editStand.form.generalInformation.stand.excerpt.placeholder');
	const contentPlaceholder = t('pages.editStand.form.generalInformation.stand.content.placeholder');

	const frExcerptEditor = useEditor(editorConfig(excerptPlaceholder, activeStandPage?.getExcerpt('fr') || ''));
	const enExcerptEditor = useEditor(editorConfig(excerptPlaceholder, activeStandPage?.getExcerpt('en') || ''));
	const jpExcerptEditor = useEditor(editorConfig(excerptPlaceholder, activeStandPage?.getExcerpt('jp') || ''));
	const frContentEditor = useEditor(editorConfig(contentPlaceholder, activeStandPage?.getContent('fr') || ''));
	const enContentEditor = useEditor(editorConfig(contentPlaceholder, activeStandPage?.getContent('en') || ''));
	const jpContentEditor = useEditor(editorConfig(contentPlaceholder, activeStandPage?.getContent('jp') || ''));

	const getTranslations = () => ({
		fr: { excerpt: frExcerptEditor?.getHTML(), content: frContentEditor?.getHTML() },
		en: { excerpt: enExcerptEditor?.getHTML(), content: enContentEditor?.getHTML() },
		jp: { excerpt: jpExcerptEditor?.getHTML(), content: jpContentEditor?.getHTML() },
	});

	return {
		editors: {
			fr: { excerpt: frExcerptEditor, content: frContentEditor },
			en: { excerpt: enExcerptEditor, content: enContentEditor },
			jp: { excerpt: jpExcerptEditor, content: jpContentEditor },
		},
		getTranslations,
	};
};
